import React, { useEffect, useRef } from 'react';

interface LogViewerProps {
  logs: string[];
  maxHeight?: number;
}

export function LogViewer({ logs, maxHeight = 160 }: LogViewerProps) {
  const bottomRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom as new logs arrive
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs.length]);

  if (logs.length === 0) return null;

  return (
    <div
      className="overflow-y-auto bg-zinc-950 rounded border border-zinc-700 p-2"
      style={{ maxHeight }}
    >
      {logs.map((line, i) => {
        const isError = line.startsWith('[ERROR]');
        const isOk = line.includes('✓') || line.includes('complete');
        return (
          <p
            key={i}
            className={[
              'text-[10px] font-mono leading-relaxed whitespace-pre-wrap',
              isError ? 'text-red-400' : isOk ? 'text-green-400' : 'text-zinc-400',
            ].join(' ')}
          >
            {line}
          </p>
        );
      })}
      <div ref={bottomRef} />
    </div>
  );
}
